<template>
  <div>
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-md-12">
          <vx-card>
            <div class="row">
              <div class="col-md-2">
                <v-select
                  :placeholder="$t('selectUser')"
                  class="w-full mt-6"
                  :closeOnSelect="true"
                  label="userName"
                  v-model="UserId"
                  :options="users"
                  :reduce="users => users.id"
                />
              </div>
              <div class="col-md-2">
                <vs-button
                  class="mt-6"
                  color="dark"
                  type="border"
                  icon="search"
                  @click="getByUser"
                >{{$t('filter')}}</vs-button>
              </div>
               <div class="col-md-2">
                <vs-button
                  class="mt-6"
                  color="dark"
                  type="border"
                  icon="search"
                  @click="selectPage(1)"
                >{{$t('bringAll')}}</vs-button>
              </div>
              <div class="col-md-6 text-right">
                <vs-button class="mt-6" to="/usermodules/add">{{ $t('addModule') }}</vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <vx-card>
            <div class="row">
              <div class="col-md-12 mt-4">
                <vs-input
                  size="small"
                  style="float:right;height:15px"
                  @input="isTyping = true"
                  :label-placeholder="$t('search')"
                  v-model="SearchText"
                />
              </div>
              <vs-table
                stripe
                :data="$store.state.userModules"
                class="w-full ml-3 mr-3"
                maxHeight="1000px"
              >
                <template slot="header">
                  <h3>{{ $t('userModules') }}</h3>
                </template>
                <template slot="thead">
                  <vs-th class="colors width">{{$t("controller")}}</vs-th>
                  <vs-th class="colors" sort-key="userName">{{$t("userName")}}</vs-th>
                  <vs-th class="colors" sort-key="moduleName">{{$t("moduleName")}}</vs-th>
                  <vs-th class="colors" sort-key="price">{{$t("price")}}</vs-th>
                  <vs-th class="colors">{{$t("mark")}}</vs-th>
                  <vs-th class="colors" sort-key="payment">{{$t("payment")}}</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr class="tr" :key="indextr" v-for="(item, indextr) in data">
                    <vs-td :data="item.id">
                      <ActionButton :id="item.id" @refresh="selectPage"></ActionButton>
                    </vs-td>

                    <vs-td :data="item.userDetail.userName">{{ item.userDetail.userName }}</vs-td>
                    <vs-td :data="item.moduleDetail.moduleName">{{ item.moduleDetail.moduleName }}</vs-td>
                    <vs-td
                      :data="item.paymentTransactionDetail.price"
                    >{{ formatPrice(item.paymentTransactionDetail.price) }}</vs-td>
                    <vs-td
                      :data="item.paymentTransactionDetail.description"
                    >{{ item.paymentTransactionDetail.description }}</vs-td>
                    <vs-td
                      :data="item.paymentTransactionDetail.paymentEntityName"
                    >{{ item.paymentTransactionDetail.paymentEntityName }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="col-md-12 mt-5">
                <vs-pagination
                  v-show="$store.state.userModules.length != 0"
                  :total="totalPage"
                  :max="9"
                  v-model="currentPage"
                  @change="selectPage"
                ></vs-pagination>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../http/http-helper";
import ActionButton from "./Buttons/ActionsButton";
import _ from "lodash";

export default {
  components: {
    ActionButton
  },
  data() {
    return {
      userModules: [],
      currentPage: 1,
      totalPage: 0,
      SearchText: "",
      isTyping: false,
      users: [],
      UserId: ""
    };
  },
  watch: {
    SearchText: _.debounce(function() {
      this.isTyping = false;
    }, 500),
    isTyping: function(value) {
      if (!value) {
        this.search(this.SearchText);
      }
    }
  },
  methods: {
    getUsers() {
      let path = "/users/getlist";
      http.get(path).then(response => {
        this.users = response.map(u => {
          return {
            id: u.id,
            userName: u.userName
          };
        });
      });
    },
    getByUser() {
      let path = "/usermodules/getlistbyuserid?userId=" + this.UserId;
      http.get(path).then(response => {
        this.userModules = response;
        this.$store.state.userModules = this.userModules;
      });
    },
    search(SearchText) {
      this.$vs.loading();
      let path = "/usermodules/getlistbypaging";
      http
        .post(path, {
          RequestPage: 1,
          SearchText: SearchText
        })
        .then(response => {
          if (response.data.lenght == 0) {
            this.$vs.loading.close();
            return this.$vs.notify({
              title: this.$t("nomatch"),
              color: "warning"
            });
          }
          this.currentPage = response.currentPage;
          this.totalPage = response.totalPage;
          this.userModules = response.data;
          this.$store.state.userModules = this.userModules;
          this.$vs.loading.close();
        });
    },
    selectPage(id) {
      if (id == "") id = 1;
      this.currentPage = id;
      let path = "/usermodules/getlistbypaging";
      http.post(path, { RequestPage: id }).then(response => {
        this.currentPage = response.currentPage;
        this.totalPage = response.totalPage;
        this.userModules = response.data;
        this.$store.state.userModules = this.userModules;
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },
  watch: {
    SearchText: _.debounce(function() {
      this.isTyping = false;
    }, 500),
    isTyping: function(value) {
      if (!value) {
        this.search(this.SearchText);
      }
    }
  },
  created() {
    this.getUsers();
  }
};
</script>

<style scoped>
.colors {
  background-color: rgb(218, 216, 216) !important;
}

.width {
  width: 110px !important;
}
</style>